module.exports = __webpack_public_path__ + "static/media/imagePicker.581ca0db.svg";